import type { DocumentPanelTarget } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentPanelSignal';
import type { ViewerListAction } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Providers/DocumentViewerProvider/ViewerListAction';
import { createSignal } from '@verclam/pulsar';

/** A request to discard the open draft, queued because it collided with another gesture — changing
 * section, opening a field or a panel, closing the sidebar, stepping to the next field, running a list
 * gesture (`list-action`), or leaving the
 * screen (`back`: through a link to `path`; `history-back`: through the browser's back button) — each
 * carrying only the primitives its own resolution needs. */
export type PendingDiscard =
	| { readonly type: 'tab'; readonly sectionKey: string }
	| { readonly type: 'field'; readonly fieldKey: string }
	| { readonly type: 'back'; readonly path: string }
	| { readonly type: 'panel'; readonly target: DocumentPanelTarget }
	| { readonly type: 'close' }
	| { readonly type: 'step'; readonly direction: 'next' | 'previous' }
	| { readonly type: 'list-action'; readonly action: ViewerListAction }
	| { readonly type: 'history-back' }
	| null;

const pendingDiscardSignal = createSignal<PendingDiscard>(null);

export const setPendingDiscard = (value: PendingDiscard): void => {
	pendingDiscardSignal.value = value;
};

export default pendingDiscardSignal;
